export default "__VITE_ASSET__bd040083__"